export const formatBankAccount = (item: any) => {
	const stringFormatBankAccount = `${item?.name} - ${item?.operationTypeValue === 1 ? `Transferência: Ag: ${item?.agency} Conta: ${item?.accountNumber}`
		:
		`${item.pixKeyTypeValue === 6 ? `Chave Pix: Ag: ${item?.agency} Conta: ${item?.accountNumber}` : `Chave Pix: ${item?.keyPix}`}`}`;

	return stringFormatBankAccount;
}; 